import { get, isEmpty, isObject } from 'lodash';
import { api } from '../app/api';

import { createContext, useEffect, useState } from 'react';

export const LanguageContext = createContext({});

function LanguageProvider({ children }) {
    const [languagesKeyVal, setlanguagesKeyVal] = useState({});
    const lang = localStorage.getItem('locale');

    const getLangDatas = async () => {
        try {
            const langsdata = await api.get(`language/get-key-value/${lang}`);
            setlanguagesKeyVal(langsdata.data);
        } catch (e) {}
    };
    const t = (key, dynamicValues) => {
        let translation = get(languagesKeyVal, key) || key;

        if (!isEmpty(dynamicValues) && isObject(dynamicValues)) {
            Object.keys(dynamicValues).forEach((placeholder) => {
                translation = translation.replace(`{${placeholder}}`, dynamicValues[placeholder]);
            });
        }

        return translation;
    };

    useEffect(() => {
        getLangDatas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <LanguageContext.Provider value={{ languagesKeyVal, t, lang }}>{children}</LanguageContext.Provider>;
}

export default LanguageProvider;
